module.exports = __webpack_public_path__ + "static/media/downloadForm.65240d73.svg";